import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  ${bp('sm')`
    padding: 0 20px;
    flex-wrap: wrap;
  `}

  ul.pagination {
    list-style: none;
    display: flex;
    justify-content: space-between;
    width: 40%;
    max-width: 100px;
    margin: auto;
    padding: 30px 0;

    a {
      color: ${props => props.theme.palette.general.dark};
    }
  }
`

const column = styled.style`
  display: flex;
  flex-direction: column;
`

export const FirstColumn = styled.div`
  ${column};
  width: 63%;
  ${bp('sm')`
    width: 100%;
  `}
`

export const SecondColumn = styled.div`
  ${column};
  width: 33%;
  ${bp('sm')`
    width: 100%;
  `}
`

export const OrderInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};

  .color-alpha {
    color: ${props => props.theme.palette.primary.alphaDark};
  }

  & > div {
    margin: auto 5px;
  }
`

export const SubscriptionInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > div {
    margin: auto 0;

    > p,
    a {
      font-size: 14px;
    }
  }

  .price-value {
    margin-right: 5%;

    span {
      font-size: 24px;
    }
  }

  .no-margin {
    margin: 0;
  }
`

export const Box = styled.div`
  ${bp('sm')`
    margin: 0 auto 20px;
  `}

  .flex-box {
    justify-content: space-between;

    a {
      margin: 1em 0;
    }
  }

  a {
    color: ${props => props.theme.palette.primary.alphaDark};
    font-weight: bold;
    text-decoration: none;

    :hover {
      color: ${props => props.theme.palette.primary.alpha};
    }
  }

  .border-box {
    border: 1px solid ${props => props.theme.palette.general.dark};
    padding: 0 10px;

    p {
      word-break: break-all;
    }
  }

  .notTooDark {
    color: ${props => props.theme.palette.general.greyDark};
  }

  strong {
    font-weight: 600;
  }

  &.shareStory {
    margin: 1em 0;
    text-align: center;
    padding: 15px 20px;
    background: ${props => props.theme.palette.primary.alphaDark};
    color: ${props => props.theme.palette.general.soft};
    ${bp('lg', 'min-width')`
      padding: 20px 40px;
    `}

    button {
      margin: auto;
      background: ${props => props.theme.palette.general.soft};
      color: ${props => props.theme.palette.general.dark};

      > div {
        padding: 12px 24px;
        white-space: normal;
      }

      :hover {
        background: ${props => props.theme.palette.general.dark};
        color: ${props => props.theme.palette.general.soft};
      }
    }
  }
`
